<template>
  <b-modal size="xl" centered  scrollable id="modal-rubrique" ref="modal-rubrique" title="Création d'une nouvelle rubrique" @hidden="resetInput">
    <b-form style="height: 450px;">
      <b-form-group label="Catégorie" label-for="rubriqueSelect">
        <b-form-select
          id="categorieSelect"
          :plain="true"
          :options="categoryOptions"
          v-model="selectedCategory"
          :class="{hasError: errors.categorie_id !== ''}">
          <template #first>
            <b-form-select-option :value="null">--- Sélectionnez une catégorie ---</b-form-select-option>
          </template>
        </b-form-select>
        <span class="field-error">{{ errors.categorie_id }}</span>
      </b-form-group>
      <b-form-group v-if="showSousCategory">
        <label for="typeSelect"><strong>Sous-catégorie</strong></label>
        <b-input-group>
          <b-form-select
            id="sousCategorieSelect"
            :plain="true"
            :options="sousCategoriesOptions"
            v-model="selectedSousCategory"
            :class="{hasError: errors.sous_categorie_id !== ''}"
            class="mr-3">
            <template #first>
              <b-form-select-option :value="null" disabled>-- Sélectionnez une sous-catégorie --</b-form-select-option>
            </template>
          </b-form-select>
        </b-input-group>
        <span class="field-error">{{ errors.sous_categorie_id }}</span>
      </b-form-group>
      <b-form-group
          label='Libellé'
          label-for='libelle'
        >
        <b-form-input id='libelle' type='text' v-model="libelle" :class="{hasError: errors.libelle !== ''}"></b-form-input>
        <span class="field-error">{{ errors.libelle }}</span>
      </b-form-group>
      <b-form-group label="Couleur de l'arrière plan">
        <div id="colorPreview" class="colorPreview" :style="'background-color : '+colors.hex"></div>
        <chrome-picker id="chromePicker" v-model="colors" @input="updateValue()" v-show="showColorPicker"/>
        <img @click="colorPicker()" class="colorPicker" id="colorPicker" src="@/assets/images/color_picker_icon_30.png">
      </b-form-group>
    </b-form>
    <template #modal-footer>
      <div class="w-100">
        <b-button
          variant="secondary"
          size="md"
          class="float-left"
          @click="resetInput; $bvModal.hide('modal-rubrique')"
        >
          Fermer
        </b-button>
        <b-button type="button" @click="save" size="md" variant="primary" class="float-right">
          <i class="fa fa-save"></i> Enregistrer
        </b-button>
      </div>
    </template>
  </b-modal>
</template>

<script>
  import {Chrome} from 'vue-color';
  import {isEmpty} from "@/utils/fileHelper";

export default {
	components: {
		'chrome-picker': Chrome,
  },
  props: {
    categoryOptions: {
      type: Array
    }
  },
  data() {
    return {
      libelle: "",
      colors: {
        hex: '#FEF2E8',
        // hsl: {h: 27, s: 0.92, l: 0.85, a: 1},
        // hsv: {h: 27, s: 0.92, v: 0.85, a: 1},
        // rgba: {r: 252, g: 213, b: 181, a: 1},
        // a: 1
      },
      showColorPicker: false,
      showSousCategory: false,
      selectedCategory: null,
      selectedSousCategory: null,
      sousCategoriesOptions: [],
      categorie_id: '',
      errors: {
        libelle: '',
        categorie_id: '',
        sous_categorie_id: ''
      },
    }
  },
  created() {
  },
  watch: {
    selectedCategory() {
      if (this.selectedCategory) {
        if (this.selectedCategory === 2) {
          this.showSousCategory = true
          this.getSousCategories()
        } else {
          this.showSousCategory = false
          this.getRubriques()
        }
      }
    },
    selectedSousCategory() {
      if (this.selectedSousCategory) {
        this.getRubriques()
      }
    }
  },
  methods: {
    save() {
      if (this.validateData()) {
        let self = this;
        let dataPost = {};
        dataPost.libelle = this.libelle;
        dataPost.couleur = this.colors.hex;
        dataPost.categorieId = this.selectedCategory;
        dataPost.sousCategorieId = this.selectedSousCategory;
        this.$store.commit("IS_LOADING", true);
        this.$axios
          .post("/espaceBibliotheque/rubrique", dataPost)
          .then(response => {
            this.$store.commit("IS_LOADING", false);
            this.$swal({
              position: "top",
              type: "success",
              title: "Création avec succès",
              text: "La rubrique a bien été créée",
              showConfirmButton: false,
              timer: 5000
            });
            this.$event.emit('refresh-rubrique-document');
            this.resetInput();
            this.$refs['modal-rubrique'].hide();
            this.$event.emit('refresh-after-new-rubrique', response.data.rubrique);
          })
          .catch(function(error) {
            self.$store.commit("IS_LOADING", false);
            self.$swal({
              position: "top",
              type: "error",
              title: "Attention !!",
              text:
                "Une erreur est survenue, si le problème persiste merci de faire un ticket au support DOSI",
              showConfirmButton: false,
              timer: 5000
            });
          });
      }
    },
    getSousCategories() {
      return new Promise((resolve, reject) => {
        this.sousCategoriesOptions = [];
        // get sous-categorie where categorie_id = this.selectedCategory
        let self = this;
        this.$axios
          .get('/espaceBibliotheque/sous-categories/' + this.selectedCategory)
          .then(response => {
            this.allSousCategories = response.data.sousCategories;
            // this.dataToTransmit.allSousCategories = response.data.sousCategories;
            for (let row of response.data.sousCategories) {
              this.sousCategoriesOptions.push({text: row.libelle, value: row.id});
            }
            resolve();
          })
          .catch(function(error) {
            resolve();
            self.$swal({
                position: "top",
                type: "warning",
                title: "Attention !!",
                text: 'Une erreur est survenue pendant la récupération des sous-catégories de document. Si le problème persiste contactez le support DOSI.',
                showConfirmButton: false,
                timer: 5000
              });
          });
      });
    },
    getRubriques() {
      return new Promise((resolve, reject) => {
        this.rubriqueOptions = [];
        let self = this;
        if (!isEmpty(this.selectedSousCategory)) {
          this.$axios
          .get('/espaceBibliotheque/rubriques/bySousCategory/' + this.selectedSousCategory)
          .then(response => {
            this.allRubrique = response.data.rubriques;
            for (let row of response.data.rubriques) {
              this.rubriqueOptions.push({ text: row.libelle, value: row.id });
            }
            resolve();
          })
          .catch(function (error) {
            resolve();
            self.$swal({
              position: "top",
              type: "warning",
              title: "Attention !!",
              text: 'Une erreur est survenue pendant la récupération des rubriques de document. Si le problème persiste contactez le support DOSI.',
              showConfirmButton: false,
              timer: 5000
            });
          });
        } else {
          this.$axios
          .get('/espaceBibliotheque/rubriques/' + this.selectedCategory)
          .then(response => {
            this.allRubrique = response.data.rubriques;
            for (let row of response.data.rubriques) {
              this.rubriqueOptions.push({ text: row.libelle, value: row.id });
            }
            resolve();
          })
          .catch(function (error) {
            resolve();
            self.$swal({
              position: "top",
              type: "warning",
              title: "Attention !!",
              text: 'Une erreur est survenue pendant la récupération des rubriques de document. Si le problème persiste contactez le support DOSI.',
              showConfirmButton: false,
              timer: 5000
            });
          });
        }
      });
    },
    clearErrors() {
      this.errors.libelle = '';
      this.errors.categorie_id = '';
    },
    validateData() {
      this.clearErrors();
      let valid = true;
      if (isEmpty(this.libelle)) {
        this.errors.libelle = 'Le libellé est obligatoire';
        valid = false;
      }
      if (isEmpty(this.selectedCategory)) {
        this.errors.categorie_id = "La catégorie est obligatoire";
        valid = false;
      }
      return valid;
    },
  	updateValue() {
      let preview = document.getElementById('colorPreview');
      preview.style.backgroundColor = this.colors.hex;
    },
    colorPicker(rubriqueId) {
      this.showColorPicker = !this.showColorPicker;
      if (this.showColorPicker) {
        let colorWheel = document.getElementById('colorPicker');

        let posWheel = colorWheel.getBoundingClientRect();
        let colorPicker = document.getElementById('chromePicker');
        let posColorPicker = colorPicker.getBoundingClientRect();
        colorPicker.style.right = '150px';
      }
    },
    resetInput() {
      this.libelle = '';
      this.colors.hex = '';
      this.rubriqueId = '';
      this.selectedCategory = '';
    },
  }
}
</script>
<style scoped>
</style>
